/* RSC Health — Homepage behaviors (rsc-home-mockup.html). One job: the rotating live-pricing
   card. Hero entrance is pure CSS; add-to-cart is handled globally by rsc-atc.js (add → /cart).
   Deals come from the section's <script data-rsc-deals> payload (prices in CENTS; us=0 → TODO).
   The hospital/insurance ("them") numbers are PLACEHOLDER settings RSC fills — never invented.
   No PHI, no analytics. */
(function () {
  'use strict';
  var root = document.querySelector('[data-rsc-home]');
  if (!root) return;

  var card = root.querySelector('[data-rsc-pricecard]');
  var dataEl = root.querySelector('[data-rsc-deals]');
  if (!card || !dataEl) return;

  var deals = [];
  try { deals = JSON.parse(dataEl.textContent) || []; } catch (e) { deals = []; }
  if (!deals.length) { card.style.display = 'none'; return; }

  var el = {
    name: card.querySelector('[data-pa-name]'), us: card.querySelector('[data-pa-us]'),
    them: card.querySelector('[data-pa-them]'), save: card.querySelector('[data-pa-save]'),
    float: card.querySelector('[data-pa-float]'), themRow: card.querySelector('.pa-row.them')
  };

  function money(cents) {
    var n = cents / 100;
    return '$' + n.toLocaleString(undefined, { maximumFractionDigits: (n % 1 ? 2 : 0) });
  }

  function render(d) {
    // fade the changing bits
    [el.name, el.us, el.them, el.save, el.float].forEach(function (x) {
      if (!x) return; x.classList.remove('fade'); void x.offsetWidth; x.classList.add('fade');
    });
    el.name.textContent = d.name || 'Featured test';
    if (d.us > 0) { el.us.textContent = money(d.us); }
    else { el.us.innerHTML = '$— <span class="pa-todo">TODO</span>'; }

    if (d.them > 0) {
      if (el.themRow) el.themRow.style.display = '';
      el.them.textContent = money(d.them);
    } else if (el.themRow) {
      el.themRow.style.display = 'none';
    }

    if (d.us > 0 && d.them > d.us) {
      var save = d.them - d.us, pct = Math.round(save / d.them * 100);
      el.save.textContent = 'You save ' + money(save);
      el.float.textContent = 'Save ' + pct + '%';
    } else if (d.us > 0) {
      el.save.textContent = 'All-in price — no surprise bills';
      el.float.textContent = 'All-in';
    } else {
      el.save.textContent = 'All-in price coming soon';
      el.float.textContent = 'All-in';
    }
  }

  var i = 0;
  render(deals[0]);
  if (deals.length > 1) {
    setInterval(function () { i = (i + 1) % deals.length; render(deals[i]); }, 3200);
  }
})();
